/* eslint-disable boundaries/no-unknown */
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TRANSLATION_CONSTANTS } from '../constants/translation';
import en from '../../../assets/i18n/en.json';
import sr from '../../../assets/i18n/sr.json';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class TranslationSetupService {
  private translate = inject(TranslateService);
  private router = inject(Router);
  private http = inject(HttpClient);

  setupTranslation() {
    this.translate.setTranslation('en', en, true);
    this.translate.setTranslation('sr', sr, true);

    const fallbackLang = TRANSLATION_CONSTANTS.FALLBACK_LANG;
    this.translate.setFallbackLang(fallbackLang);

    const storedLang = localStorage.getItem(TRANSLATION_CONSTANTS.STORAGE_KEY);
    let currentLang = storedLang || fallbackLang;

    if (!storedLang || !TRANSLATION_CONSTANTS.LANGUAGES.includes(storedLang)) {
      localStorage.setItem(TRANSLATION_CONSTANTS.STORAGE_KEY, fallbackLang);
      currentLang = fallbackLang;
    }

    this.translate.use(currentLang);
  }

  updateLanguage(language: string): boolean {
    if (TRANSLATION_CONSTANTS.LANGUAGES.includes(language)) {
      this.translate.use(language);
      localStorage.setItem(TRANSLATION_CONSTANTS.STORAGE_KEY, language);

      this.reloadFeatureTranslations(language);

      return true;
    }
    return false;
  }

  private reloadFeatureTranslations(language: string): void {
    const feature = this.getCurrentFeature(this.router.routerState.root);

    if (feature) {
      this.http.get(`/feature/${feature}/i18n/${language}.json`).subscribe({
        next: (translations: any) => {
          this.translate.setTranslation(language, translations, true);
        },
        error: (error) => {
          console.warn(
            `Failed to load feature translations for ${feature}:`,
            error,
          );
        },
      });
    }
  }

  private getCurrentFeature(route: ActivatedRoute): string | null {
    let currentRoute: ActivatedRoute | null = route;

    while (currentRoute) {
      if (currentRoute.snapshot.data['feature']) {
        return currentRoute.snapshot.data['feature'];
      }

      if (currentRoute.children.length > 0) {
        for (const child of currentRoute.children) {
          const feature = this.getCurrentFeature(child);
          if (feature) {
            return feature;
          }
        }
      }

      currentRoute = currentRoute.firstChild;
    }

    return null;
  }
}
